import React from 'react';
import {connect} from "react-redux";
import SessionData from '../components/SessionData';
import FixedButton from "./FixedButton";

const SessionList=(props)=>{
    return(
    <div id="dialog_top">
        <div className='session-list'>
            {props.data && props.data.map((data, index)=>
            {return <SessionData event={data} key={index}/>})}
        </div>
        <div className="up-button">
            <FixedButton id="dialog_top" src="../images/buttons/up_gray.png" srcOn="../images/buttons/up_on.png"/>
        </div>
    </div>)
};

const mapStateToProps=(state)=>({data:state.data.userSessions});
export default connect(mapStateToProps)(SessionList);